import * as React from 'react';

import type {SelectMenuOption} from '../action-menu/action-menu';
import {ActionableHeader} from '../actionable-header/actionable-header';
import type {ActionableHeaderStatusBadgeProps} from '../actionable-header/actionable-header';
import {Card} from '../card/card';

import styles from './list-row-wide-with-header.module.css';

type Props = {
    isArchived?: boolean;
    name: string;
    to: string;
    metadataPrimary?: string | React.ReactNode | null | undefined;
    metadataSecondary?: string | React.ReactNode | null | undefined;
    status?: ActionableHeaderStatusBadgeProps;
    secondaryLink?: {
        text: string;
        onClick: () => void;
    };
    options?: SelectMenuOption[];
    getActionMenuRef?: (arg1?: HTMLElement | null | undefined) => void;
    children: React.ReactNode;
};

export function ListRowWideWithHeader(props: Props) {
    const {children, ...restProps} = props;

    return (
        <Card hasBorder={true}>
            <ActionableHeader {...restProps} />
            <div className={styles['content-container']}>{children}</div>
        </Card>
    );
}
